<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
  mounted() {
    console.log(document.body.clientWidth)
  }
}
</script>
<style lang="less">
html,
body,
#app {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
  height: 100%;
  // min-width: 990px;
  font-family: 'Helvetica Neue', Helvetica, Arial, 'PingFang SC',
    'Hiragino Sans GB', 'Heiti SC', 'Microsoft YaHei', 'WenQuanYi Micro Hei',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // text-align: center;
  color: #2c3e50;
}
body {
  font-size: 18px !important;
}
@media (max-width: 1440px) {
  body {
    font-size: 16px !important;
  }
}
@media (max-width: 1200px) {
  body {
    font-size: 16px !important;
  }
}
@media (max-width: 992px) {
  body {
    font-size: 16px !important;
  }
}
@media (max-width: 768px) {
  body {
    font-size: 14px !important;
  }
}
</style>
